import {useMemo} from 'react';

import {Header, Tabs} from '@/components';
import type {TabItem} from '@/types';

import ParameterStoreTable from './ParameterStoreTable';
import useParameterStore from './useParameterStore';

export default function ParameterStore() {
  const {parameters, isLoading} = useParameterStore();

  const tabs: TabItem[] = useMemo(
    () => [
      {
        id: 'referral-params',
        title: 'Referral Params',
        content: (
          <ParameterStoreTable
            type="referralParams"
            data={parameters}
            loading={isLoading}
          />
        ),
      },

      {
        id: 'reward-params',
        title: 'Reward Params',
        content: (
          <ParameterStoreTable
            type="rewardParams"
            data={parameters}
            loading={isLoading}
          />
        ),
      },
    ],
    [parameters, isLoading],
  );
  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title="Parameter Store" />
      <Tabs tabs={tabs} queryKey={'tab'} />
    </main>
  );
}
